import React, {useContext} from 'react'
import HeaderWithSelect from "app/react/components/HeaderWithSelect";
import LogoPackages from "app/react/components/logos/LogoPackages";
import Logos from "app/react/components/logos/Logos";
import LogosContext from "app/react/components/logos/LogosContext";

export default function LogosContent () {

  const { headerTitle, headerText, selectLabel, selectOptions, setSelectedOption } = useContext(LogosContext)

  const handleOnSelectChange = (e) => {
    setSelectedOption(e.target.value)
  }

  return (
    <section id="logos" className="dm-logos">
      <div className="dm-logos__inner dm-page-container">
        <HeaderWithSelect
          title={headerTitle}
          text={headerText}
          label={selectLabel}
          selectOptions={selectOptions}
          onSelectChange={handleOnSelectChange}
        />
        <LogoPackages/>
        <Logos/>
      </div>
    </section>
  )
}